<template>
  <div>
    <el-row :gutter="20" type="flex" justify="space-between">
      <el-col v-for="item in shipmentSumlist" :key="item.type">
        <el-card class="card" shadow="hover" style="border-color: #ededed;">
          <div style="text-align: center;">
            <span @click="transfer(item.type)">
              <el-link
                type="primary"
                :underline="false"
                style="font-size: 18px;"
              >
                {{ item.name }}</el-link
              >
            </span>
            <br />
            <span style="font-size: 30px;">{{ item.count }}</span>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="12">
        <CustTable />
      </el-col>
      <el-col :span="12">
        <FactoryTable />
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <SalesPersonTable />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import SalesPersonTable from './sales-person-table'
import CustTable from './cust-table'
import FactoryTable from './factory-table'
export default {
  components: { SalesPersonTable, CustTable, FactoryTable },
  props: {},
  data() {
    return {
      shipmentSumlist: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.shipmentSumlist = []
      this.$api.shipmentDashboardSumDataApi({}).then((res) => {
        this.loading = false
        this.shipmentSumlist = res.body.data
      })
    },

    transfer(type) {
      switch (type) {
        case 'B':
          this.$router.push({
            name: 'transport-wait-booking',
          })
          break
        case 'L':
          this.$router.push({
            name: 'transport-wait-productionLoad',
          })
          break
        case 'C':
          this.$router.push({
            name: 'transport-wait-exportDeclaration',
          })
          break
        case 'S':
          this.$router.push({
            name: 'transport-wait-shipment',
          })
          break
        case 'M':
          this.$router.push({
            name: 'transport-wait-settlement',
          })
          break
        default:
          return
      }
    },
  },
}
</script>
